import { render } from "./MermaidComponent.vue?vue&type=template&id=c95e7196"
import script from "./MermaidComponent.vue?vue&type=script&lang=js"
export * from "./MermaidComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__